export const FETCH_TIMESLOTS_REQUEST = "FETCH_TIMESLOTS_REQUEST";
export const FETCH_TIMESLOT_REQUEST = "FETCH_TIMESLOT_REQUEST";
export const CHANGE_BLOCKING_TIMESLOT_REQUEST = "CHANGE_BLOCKING_TIMESLOT_REQUEST";
export const ADD_SCHEDULE_REQUEST = "ADD_SCHEDULE_REQUEST";
export const UPDATE_SCHEDULE_REQUEST = "UPDATE_SCHEDULE_REQUEST";
export const DELETE_SCHEDULE_REQUEST = "DELETE_SCHEDULE_REQUEST";
export const CHANGE_STATUS_SCHEDULE_REQUEST = "CHANGE_STATUS_SCHEDULE_REQUEST";
export const FETCH_BOOKING_BY_OFFICE_ID_REQUEST = "FETCH_BOOKING_BY_OFFICE_ID_REQUEST";
export const FETCH_OFFICES_REQUEST = "FETCH_OFFICES_REQUEST";
export const CREATE_OFFICES_REQUEST = "CREATE_OFFICES_REQUEST";
export const UPDATE_OFFICES_REQUEST = "UPDATE_OFFICES_REQUEST";
export const UPDATE_OFFICES_WEIGHT_REQUEST = "UPDATE_OFFICES_WEIGHT_REQUEST";
export const CANCEL_BOOKING_REQUEST = "CANCEL_BOOKING_REQUEST";
export const CHECK_BOOKING_REQUEST = "CHECK_BOOKING_REQUEST";
export const TOGGLE_ASSISTANTSHIP_NOTIFY_REQUEST = "TOGGLE_ASSISTANTSHIP_NOTIFY_REQUEST";
export const DELETE_ASSISTANTSHIP_REQUEST = "DELETE_ASSISTANTSHIP_REQUEST";
export const ADD_ASSISTANTSHIP_REQUEST = "ADD_ASSISTANTSHIP_REQUEST";
export const EDIT_ASSISTANTSHIP_REQUEST = "EDIT_ASSISTANTSHIP_REQUEST";
export const ADD_PRACTICE_REQUEST = "ADD_PRACTICE_REQUEST";
export const UPDATE_PRACTICE_REQUEST = "UPDATE_PRACTICE_REQUEST";
export const FETCH_PRACTICE_REQUEST = "FETCH_PRACTICE_REQUEST";
export const DELETE_PRACTICE_REQUEST = "DELETE_PRACTICE_REQUEST";
export const CLEAR_SPECIALTY_PRACTICES = "CLEAR_SPECIALTY_PRACTICES";
export const CREATE_TIMESLOTS_FROM_SCHEDULE_REQUEST = "CREATE_TIMESLOTS_FROM_SCHEDULE_REQUEST";
export const UPDATE_BOOKING_FORCESHOW_TIMESLOT_REQUEST = "UPDATE_BOOKING_FORCESHOW_TIMESLOT_REQUEST";
